class Modal {

	constructor($modal) {
		this.$modal = $modal;
		this.container = null;
		this.baseClass = 'c-modal';
		this.html = `
			<div id="modal" class="${this.baseClass}">
				<div class="${this.baseClass}__navbar">
					<span class="${this.baseClass}__close">X</span>
				</div>
				<div class="${this.baseClass}__content">
					<div class="c-loader__container">
						<span class="c-loader"></span> Bezig met laden ...
					</div>
				</div>
			</div>
		`;
		this.imageSlide = `
			<div>
				<div class="${this.baseClass}__slide">
					<svg id="placeholder">
				</div>
			</div>
		`;
		this.noteSlide = `
			<div>
				<div class="${this.baseClass}__slide">
					<p></p>
				</div>
			</div>
		`;

		this._render();
	}

	/**
	 *  
	 **/
	openModal() {
		$('body').addClass('c-modal--open');
		$('.c-modal__container').css('display', 'flex');
		this._loadContent();
	}

	/**
	 * 
	 **/
	closeModal() {
		$('body').removeClass('c-modal--open');
		$('.c-modal__container').css('display', 'none');
	}

	/**
	 * 
	 **/
	handleOrientation() {
		if (window.matchMedia("(orientation: portrait)").matches) {
		   // you're in PORTRAIT mode
			$('.js-slider').slick('slickSetOption', 'verticalSwiping', 'true', true);
		}

		if (window.matchMedia("(orientation: landscape)").matches) {
		   // you're in LANDSCAPE mode
			$('.js-slider').slick('slickSetOption', 'verticalSwiping', 'false', true);
		}
	}

	/**
	 * Load the content for the modal 
	 **/
	_loadContent() {
		let $contentBlock = $('.c-modal__content');
		const loadingblock = `
			<div class="c-loader__container">
				<span class="c-loader"></span> Bezig met laden ...
			</div>
		`;

		$contentBlock.html(loadingblock);

		let imageContainer = document.createElement('div');
		imageContainer.className = 'c-modal__slider js-slider';

		$.ajax({
			method: "GET",
            url: "/api/profile/membercard?ns=" + new Date().getTime(),
			accepts: {
				'json': 'application/json'
			},
			dataType: 'json'
		}).done(data => {

			let	topHeight = 0,
				topWidth = 0;

			$contentBlock.empty();

			if (data.Error) {

				const $note = $(this.noteSlide);
				$note.find('p').text(data.Error || 'We konden geen NGF pas ophalen. Probeer het later nogmaals.');

				$contentBlock.append($note);
				return false;
			}
			data.Cards.forEach(card => {
				const $slide = $(this.imageSlide);
				let height = card.substr(card.indexOf('height="') + 8, 3);
				let width = card.substr(card.indexOf('width="') + 7, 3);

				topHeight = height > topHeight ? height : topHeight;
				topWidth = width > topWidth ? width : topWidth;

				$slide.find('#placeholder').replaceWith(card);

				$(imageContainer).append($slide);
			});

			$contentBlock.css('height', topHeight);
			$contentBlock.css('width', topWidth);

			var configuration = {
				infinite: false,
				prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow slick-arrow--outside" aria-label="Previous" role="button"></button>',
				nextArrow: '<button type="button" data-role="none" class="slick-next slick-arrow slick-arrow--outside" aria-label="Next" role="button"></button>',
				dots: true
			}

			if (window.matchMedia("(orientation: portrait)").matches) {
			   // you're in PORTRAIT mode
				configuration.verticalSwiping = true;
			}

			if (window.matchMedia("(orientation: landscape)").matches) {
			   // you're in LANDSCAPE mode
				configuration.verticalSwiping = false;
			}

			// add carousel to content block
			$contentBlock.append(imageContainer);

			$('.js-slider').slick(configuration);
		});
	}

	/**
	 * Render the modal 
	 **/
	_render() {
		this.container = document.createElement('div');
		this.container.className = `${this.baseClass}__container`;
		let overlay = document.createElement('div');
		overlay.className = `${this.baseClass}__overlay`;
		this.container.innerHTML = this.html;
		this.container.appendChild(overlay);
		document.body.appendChild(this.container);

		this._initEvents();
	}

	/**
	 * Initialize all the events 
	 **/
	_initEvents() {
		//click event on the trigger to open the modal
		this.$modal.on('click.trigger', this.openModal.bind(this));

		//prevent contextmenu in modal
		this.container.addEventListener('contextmenu', function (e) {
			e.preventDefault();
			return false;
		});

		//click event for closing the modal
		$('.' + this.baseClass + '__close').on('click.cross', this.closeModal);

		//detect screen orientation
		$(window).on('resize', this.handleOrientation);
	}


}

export default Modal;